module.exports = __webpack_public_path__ + "static/media/logo.6b8f0a88.svg";